// Import ----------------------------------------------------------------------

// Nuxt / Vendor
import Vue from "vue";

// Project
import { MetaData } from "~/libs/MetaData";
import { ContentNode } from "~/libs/Types";

// Export ----------------------------------------------------------------------

export default Vue.extend({

    // Methods / Functions  ----------------------------------------------------

    methods: {

        /**
         * Format and build meta data object.
         */
        buildMetaData (node: ContentNode) {
            const siteData = this.$store.state.site;

            // Handle ENV URL override
            if (this.$isServer && process.env.SITE_URL) {
                siteData.siteUrl = process.env.SITE_URL;
            }

            // Create MetaData instance
            const metaData = new MetaData(siteData, node);

            if (this.$isServer && process.env.MATOMO_TMS_URL) {
                metaData.setMatomoTmsUrl(process.env.MATOMO_TMS_URL);
            }

            return metaData.build();
        }
    }

    // -------------------------------------------------------------------------
});
